import { length } from 'ramda';

import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toRichTextFromProp, toTextFromProp } from '../../fields/text';

export const faqSlice = ({ primary }) => {
  const question = toTextFromProp('question', primary);
  const answer = toRichTextFromProp('answer', primary);

  if (question && length(answer)) {
    return clear({
      type: CommonSliceType.FAQ,
      question,
      answer,
    });
  }
};
